import { WindowHelper } from '@core/helpers/window.helper';
import { environment } from 'src/environments/environment';

export class BaseService {
  protected baseUrl = '';

  public constructor() {
    this.baseUrl = BaseService.getBaseUrl();
  }

  public static getBaseUrl() {
    let baseUrl: string;
    if (environment.production) {
      baseUrl = WindowHelper.getBaseUrlClient() + environment.apiUrl;
    } else {
      baseUrl = environment.apiUrl;
    }

    
    return baseUrl.replace(/\/$/, ""); // remove trailing backslash    
  }
}
